import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const CART_SYNC_TRACING_ACTIONS = {
  traceCartSync: createAction(
    '[NGRXTrace - Order] Track Cart Sync Process',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceCartSyncSuccess: createAction(
    '[NGRXTrace - Order] Track Cart Sync Process Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
  traceCartSyncFail: createAction(
    '[NGRXTrace - Order] Track Cart Sync Process Fail',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
